import {
  Flex,  
  Text,
  Card,
  cardSelectableBehavior,
  Grid,
  cardsContainerBehavior,
  Checkbox,
  Button,  
  AttendeeIcon,  
} from '@fluentui/react-northstar';
import * as React from 'react';
import * as _ from 'lodash';

type SelectableCardProps = {
  index?: number;
  media?: any;
  name?: string;
  selected?: boolean;
  onClick?: (e: React.SyntheticEvent) => void;
};

const SelectableCard: React.FC<SelectableCardProps> = ({ media, name, index, selected, onClick, ...rest }) => {
  return (
    <Card
      id={`card${index}`}
      accessibility={cardSelectableBehavior}
      aria-labelledby={`card${index}`}
      aria-roledescription="user card"
      onClick={onClick}
      selected={selected}
      fluid
      {...rest}
    >
      <Card.Header>
              {media != null ? media
                  : <AttendeeIcon/>
              }
      </Card.Header>
          <Card.TopControls>
              <Checkbox checked={selected} onClick={onClick} />
      </Card.TopControls>

      <Card.Body>
        <Flex column gap="gap.small">
              <Text weight='bold' content={name}/>
        </Flex>
      </Card.Body>
    </Card>
  );
};

type SelectableCardsGridActions =
  | { type: 'TOGGLE_ITEM'; selected: boolean; index: string }
  | { type: 'TOGGLE_ALL'; selected: boolean };

type SelectableCardsGridState = Record<string, boolean>;

const selectableCardsGridStateReducer: React.Reducer<SelectableCardsGridState, SelectableCardsGridActions> = (
  state,
  action,
) => {
  switch (action.type) {
    case 'TOGGLE_ITEM': {
      return { ...state, [action.index]: action.selected };
    }
    case 'TOGGLE_ALL': {
      return _.mapValues(state, () => action.selected);
    }
  }
};

export function CardSelectableGrid(props){
  // Component setup
    const cards = props.items
        .map((item, index) => ({ index: index, media: item.media, name: item.header, checked: item.checked }));
  const initialState: SelectableCardsGridState = cards.reduce((cards, card) => {
    cards[card.index] = true;
    return cards;
  }, {});
  const [state, dispatch] = React.useReducer(selectableCardsGridStateReducer, initialState);
  const cardList =
        cards.map(card => {
            return (
                <SelectableCard
                    key={card.index}
                    index={card.index}
                    name={card.name}
                    media={card.media}
                    aria-label={`${card.name} ${card.index} of ${props.items.length}`}
                    onClick={() => {
                        dispatch({ type: 'TOGGLE_ITEM', selected: !card.checked, index: `${card.index}` });
                        props.handleChangeSelection(card.index, !card.checked);
                    }}
                    selected={card.checked}
                />
            );
        });
    let userAgentString = navigator.userAgent;
    // Detect Internet Explorer
    let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("Edge") > -1 ||
        userAgentString.indexOf("rv:") > -1;
    const anyChecked = (element) => element === true;
    const stateOfAnyChecked = Object.values(state).some(anyChecked);
      return (
          <Flex column gap='gap.medium'>
            <Flex inline gap='gap.medium'>
              <Button
                content={stateOfAnyChecked ? 'Unselect All' : 'Select All'}
                primary={stateOfAnyChecked}
                onClick={() => {
                    dispatch({ type: 'TOGGLE_ALL', selected: !stateOfAnyChecked });                
                    props.handleChangeSelection(null, null, !stateOfAnyChecked);
                }}
              />
              </Flex>
              {props.isMobile || IExplorerAgent ? cardList :
                  <Grid accessibility={cardsContainerBehavior}>
                  {cardList}        
          </Grid>}
        </Flex>
      );
}